import { motion } from "framer-motion";
import { Waves, TrainFront, ShoppingBasket } from "lucide-react";
import { useLanguage } from "@/i18n";

const ICONS = [Waves, TrainFront, ShoppingBasket];

const LocationSection = () => {
  const { t } = useLanguage();
  return (
    <section id="posizione" data-testid="location-section" className="py-20 lg:py-32 px-6 sm:px-12 lg:px-20 bg-[#0D253A] text-[#F8F5F0] relative grain">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-5"
        >
          <p className="text-xs uppercase tracking-[0.25em] font-mono-alt font-semibold text-[#C86D51] mb-4">{t.location.eyebrow}</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight">{t.location.title}</h2>
          <p className="mt-5 text-base sm:text-lg text-[#F8F5F0]/75 leading-relaxed">{t.location.text}</p>

          <div className="mt-10 flex flex-col gap-7">
            {t.location.points.map((p, i) => {
              const Icon = ICONS[i];
              return (
                <motion.div
                  key={p.title}
                  data-testid={`location-point-${i}`}
                  initial={{ opacity: 0, x: -24 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: i * 0.12 }}
                  className="flex gap-4"
                >
                  <span className="mt-1 p-2.5 h-fit rounded-full bg-[#C86D51]/15 text-[#C86D51]">
                    <Icon className="w-5 h-5" />
                  </span>
                  <div>
                    <h3 className="font-display text-xl">{p.title}</h3>
                    <p className="mt-1 text-sm text-[#F8F5F0]/65 leading-relaxed">{p.desc}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="lg:col-span-7"
        >
          <div data-testid="location-map" className="rounded-2xl overflow-hidden border border-white/10 shadow-[0_30px_70px_-30px_rgba(0,0,0,0.6)]">
            <iframe
              title={t.location.mapTitle}
              src="https://www.google.com/maps?q=Isola+delle+Femmine,+PA,+Italia&z=13&output=embed"
              className="w-full h-[420px] lg:h-[520px] grayscale-[25%] contrast-[1.05]"
              loading="lazy"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default LocationSection;
